import { styled } from "styled-components";

export const DropBoxWrapper = styled.div`
  width: 146px;
  height: 22px;
  opacity: 1;
  gap: 5px;
  border-radius: 2.1px;
  padding: 4px 6px;
  border: 0.5px solid #b7b7b7;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  > img {
    position: absolute;
    right: 6px;
    width: 8px;
    height: 7px;
    cursor: pointer;
  }

  > .name {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
  }

  > input {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
  }
`;

export const DropBoxItemWrapper = styled.div`
  position: absolute;
  top: 24px;
  left: 0;
  width: 100%;
  background: rgb(255, 255, 255);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 3.71px 3.71px 0px;
  border: 1px solid rgb(217, 217, 217);
  box-sizing: border-box;
  overflow-y: auto;
  max-height: 250px;
  scrollbar-width: none;
`;

export const DropBoxItem = styled.div<{ selected: boolean }>`
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;

  ${(p) =>
    p.selected
      ? `
    background: var(--Purple-300, #6436e7);
    color: #fff;

    svg path {
      stroke: #fff;
    }
    `
      : ""}

  svg path {
    stroke: var(--Black-400, #444);
  }
`;
